<ng-template #dateTimeScheduleModalTemplateRef>
  <form [formGroup]="form">
    <div class="grid">
      <span class="labels" translate="date-time-modal/timezone"></span>
      <div class="field">
        <app-select
          [enableTypeahead]="true"
          [control]="form.controls.timezone"
          [items]="timezoneItems"
          [noFloatingLabel]="true"
          [labelKey]="'date-time-modal/timezone'">
        </app-select>
      </div>

      <span class="labels" translate="date-time-modal/date"></span>
      <div class="date field">
        <mat-form-field>
          <input matInput formControlName="date" [matDatepicker]="picker" data-testid="date-input" />
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      </div>

      <span class="labels" translate="date-time-modal/time"></span>
      <div class="field">
        <ngx-mat-timepicker-field
          (timeChanged)="updateTime($event)"
          [format]="24"
          [defaultTime]="startHours"></ngx-mat-timepicker-field>
      </div>
    </div>

    <mat-error
      *ngIf="form.dirty && form.hasError('past')"
      translate="date-time-modal/error/past"
      data-testid="date-error-past"></mat-error>

    <mat-error data-testid="date-error-range" *ngIf="form.dirty && form.hasError('range')">{{
      rangeErrorMessage
    }}</mat-error>
  </form>
</ng-template>
